import { Link } from 'react-router-dom';

export function SuspendedPage() {
  return (
    <div className="text-center">
      <h4 className="mt-0">Account Suspended</h4>
      <p className="text-muted">
        This account is currently suspended. Please contact ADS support if you need access restored.
      </p>
      <Link to="/welcome" className="btn btn-primary">
        Return Home
      </Link>
    </div>
  );
}